import "./avc.css";
import { Link } from "react-router-dom";
import Footer from "./footer";
import React, { useState, useEffect, Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Chairman from "../images/Chairman.jpg";
import MainBg from "../images/Leadership main bg.jpg";
import men from "../images/men.png";
import Mobilemen from "../images/mobile-men.png";
import Ceo from "../images/Ojiromayo.jpg";
import ED from "../images/Abayomi.jpg";
import Internal from "../images/Yomi.jpg";
import InternalAud from "../images/Segun.jpg";
import RiskMMng from "../images/Kingsley.jpg";
import ready from "../images/avc-ready.jpg";
import benefits from "../images/avc-benefits.jpg";
import avcBanner from "../images/avc-banner.jpg";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "swiper/css/navigation";
import AOS from 'aos';


import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";

const client = new ApolloClient({
  link: new HttpLink({
    uri: "https://pensure-cms.inspireleadership.biz/graphql",
  }),
  cache: new InMemoryCache(),
});

const Avc = () => {
  const [heroBanner, setHeroBanner] = useState([]);
  const [heroMobile, setHeroMobile] = useState([]);
  const [productText, setProductText] = useState("");
  const [productTextContd, setProductTextContd] = useState("");
  const [businessSections, setBusinessSections] = useState([]);
  const [listSections, setListSections] = useState([]);
  const [productInfo, setProductInfo] = useState([]);

  window.scrollTo(0, 0);
  useEffect(() => {
  
     AOS.init({
      offset: 0,
      duration: 1000,
      once: true
    });
  
      
  }, [])
  

  useEffect(() => {
    client
      .query({
        query: gql`
          query NewQuery {
            pages {
              edges {
                node {
                  additionalContribution {
                    hero {
                      buttonLink
                      buttonName
                      caption
                      heading
                      image {
                        mediaItemUrl
                      }
                    }
                    heromobile {
                      buttonLink
                      buttonName
                      caption
                      heading
                      image {
                        mediaItemUrl
                      }
                    }
                    listSection {
                      heading
                      image {
                        mediaItemUrl
                      }
                      list {
                        items
                      }
                    }
                    productInfo {
                      explanation
                      heading
                    }
                    productText
                    productTextContd
                    section {
                      buttonLink
                      buttonName
                      explanation
                      heading
                      image {
                        mediaItemUrl
                      }
                    }
                  }
                }
              }
            }
          }
        `,
      })
      .then((result) => {
        console.log(result);
        setHeroBanner(
          result.data.pages.edges[6].node.additionalContribution.hero,
        );
        setHeroMobile(
          result.data.pages.edges[6].node.additionalContribution.heromobile,
        );
        setProductText(
          result.data.pages.edges[6].node.additionalContribution.productText,
        );
        setProductTextContd(
          result.data.pages.edges[6].node.additionalContribution
            .productTextContd,
        );
        setProductInfo(
          result.data.pages.edges[6].node.additionalContribution.productInfo,
        );
        setListSections(
          result.data.pages.edges[6].node.additionalContribution.listSection,
        );
        setBusinessSections(
          result.data.pages.edges[6].node.additionalContribution.section,
        );
      });
  }, []);

  let heroBannerDisplay;
  let heroMobileBannerDisplay;
  let listSectionsDisplay;
  let productInfoDisplay;
  let businessSectionsDisplay;

  if (heroBanner.length > 0) {
    heroBannerDisplay = heroBanner.map((banner, i) => (
      <div className="avc-cover">
        <img className="avc-bg" src={banner.image.mediaItemUrl} />
        <div className="avc-content">
          <div className="avc-txt">
            <h1 className="avc-h1" data-aos="zoom-in" data-aos-delay="200"> {banner.heading} </h1>
            <p className="grey-p-avc" data-aos="fade-up" data-aos-delay="200">{banner.caption}</p>
            <a className="btn-trns" href={banner.buttonLink} data-aos="fade-up" data-aos-delay="200">
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (heroMobile.length > 0) {
    heroMobileBannerDisplay = heroMobile.map((banner, i) => (
      <div className="avc-cover">
        <img className="avc-bg" src={banner.image.mediaItemUrl} />
        <div className="avc-content">
          <div className="avc-txt">
            <h1 className="avc-h1 " data-aos="zoom-in" data-aos-delay="200"> {banner.heading} </h1>
            <p className="grey-p-avc" data-aos="fade-up" data-aos-delay="200">{banner.caption}</p>
            <a className="btn-trns" href={banner.buttonLink} data-aos="fade-up" data-aos-delay="200">
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (productInfo.length > 0) {
    productInfoDisplay = productInfo.map((info, i) =>
      i > 2 && i < 5 ? (
        <div className="card cbs-crd-2 text-start">
          <figure className="compact-settings-cbs-works">
            <p className="cbs-works-numeral">{i + 1}</p>
            <figcaption>
              <h5 className="card-subtitle pb-2 statement-hdr" data-aos="fade-up" data-aos-delay="200">
                {info.heading}
              </h5>
              <p className="card-text grey-p-cbs" style={{ fontSize: "16px" }} data-aos="fade-up" data-aos-delay="200">
                {info.explanation}
              </p>
            </figcaption>
          </figure>
        </div>
      ) : (
        <div className="card cbs-crd text-start">
          <figure className="compact-settings-cbs-works">
            <p className="cbs-works-numeral">{i + 1}</p>
            <figcaption>
              <h5 className="card-subtitle pb-2 statement-hdr" data-aos="fade-up" data-aos-delay="200">
                {info.heading}
              </h5>
              <p className="card-text grey-p-cbs" style={{ fontSize: "16px" }} data-aos="fade-up" data-aos-delay="200">
                {info.explanation}
              </p>
            </figcaption>
          </figure>
        </div>
      ),
    );
  }

  if (businessSections.length > 0) {
    businessSectionsDisplay = businessSections.map((section, i) =>
      i % 2 ? (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5 z-value"
        >
          <div className="d-flex justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>

          <div className="values compact-section">
            <h3 className="h3 rsa-h3" data-aos="fade-up" data-aos-delay="200">{section.heading} </h3>
            <p
              className="grey-p pt-3 pb-2"
              style={{ fontSize: "16px", color: "#545454" }}
            data-aos="fade-up" data-aos-delay="200">
              {section.explanation}
            </p>

            <a
              class="open-acc-btn grey-p mt-1"
              href={section.buttonLink}
              role="button"
              data-aos="fade-up" data-aos-delay="200"
            
            >
              {section.buttonName}{" "}
              <FontAwesomeIcon className="rsa-dwn-arr" icon={faArrowRight} />
            </a>
          </div>
        </div>
      ) : (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5 z-value"
        >
          <div className="values-avc compact-section">
            <h3 className="h3 rsa-h3" data-aos="fade-up" data-aos-delay="200"> {section.heading} </h3>
            <p
              className="grey-p pt-3 pb-2"
              style={{ fontSize: "16px", color: "#545454" }}
            data-aos="fade-up" data-aos-delay="200">
              {section.explanation}
            </p>

            <a
              class="open-acc-btn grey-p mt-1"
              href={section.buttonLink}
              role="button"
              data-aos="fade-up" data-aos-delay="200"
         
            >
              {section.buttonName}
              <FontAwesomeIcon className="rsa-dwn-arr" icon={faArrowRight} />
            </a>
          </div>

          <div className="d-flex justify-content-end">
            <img id="avc-img" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ),
    );
  }

  if (listSections.length > 0) {
    listSectionsDisplay = listSections.map((section, i) =>
      i % 2 ? (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5"
        >
          <div className="pension-div1 pb-2">
            <h3 className="rma-h3 pb-2" data-aos="fade-up" data-aos-delay="200"> {section.heading} </h3>

            <hr
              className="btm-bdr"
              style={{ borderTop: "none", width: "600px" }}
            />

            <ul
              id="custom-square-id"
              className="pt-2 ps-3 custom-square"
              style={{ listStyleType: "square", paddingLeft: "20px" }}
            >
              {section.list.map((items, i) => (
                <li className="grey-p-rma pt-4" style={{ color: "#3B475A" }} data-aos="fade-up" data-aos-delay="200">
                  {items.items}
                </li>
              ))}
            </ul>
          </div>

          <div className="d-flex d-block d-sm-none justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ) : (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between pb-5"
        >
          <div className="pension-div1 pb-2">
            <h3 className="rma-h3 pb-2" data-aos="fade-up" data-aos-delay="200">{section.heading}</h3>

            <hr
              className="btm-bdr"
              style={{ borderTop: "none", width: "600px" }}
            />

            <ul
              className="pt-2 ps-3 custom-square"
              style={{ listStyleType: "square", paddingLeft: "20px" }}
            >
              {section.list.map((items, i) => (
                <li className="grey-p-rma pt-3" style={{ color: "#3B475A" }} data-aos="fade-up" data-aos-delay="200" >
                  {items.items}
                </li>
              ))}
            </ul>
          </div>

          <div className="d-flex justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ),
    );
  }

  return (
    <>
      <div className="avc-container d-block d-sm-none">{heroBannerDisplay}</div>

      <div className="avc-container d-none d-sm-block">
        {heroMobileBannerDisplay}
      </div>

      <div className="containeer">
        <div
          id="mobile-view"
          className="d-flex justify-space-between pt-5 padding-section-standard-bottom"
        >
          <div className=" width-fifty" data-aos="fade-up" data-aos-delay="200">
            <h2 className="avc-h2 pb-4">What is AVC? </h2>
          </div>
          <div className=" width-fifty abt-para">
            <p className="grey-p-avc grey-color">{productText}</p>

            <p className="pt-3 grey-p-avc grey-color">{productTextContd}</p>
          </div>
        </div>

        {listSectionsDisplay}
      </div>

      <div className="black-cont-avc">
        <div
          id="mobile-view"
          className="containeer row d-flex justify-content-between text-center "
        >
          <div className="text-center pb-5">
            <p className="orange-p-avc pb-2" data-aos="fade-up" data-aos-delay="200">AVC ENROLLMENT PROCESS</p>
            <h2 className="avc-h2" style={{ color: "#FFFFFF" }} data-aos="fade-up" data-aos-delay="200">
              How to Get Started?
            </h2>
          </div>
          <div id="mobile-view" className="d-flex justify-content-between" data-aos="fade-in" data-aos-delay="200">
            {productInfoDisplay}
          </div>
        </div>
      </div>

      <div className="containeer">{businessSectionsDisplay}</div>
      <Footer/>
           <div className='height-prod'> 

              </div>

    </>
  );
};

export default Avc;
